// Read API for the admin Store Orders tab. Rows are written by the
// shopify-webhook edge function; this module only reads.
import { supabase } from '../lib/supabase';

export interface StoreOrderLineItem {
  title: string;
  variant_title: string | null;
  variant_id: string | null;
  quantity: number;
  price: string | null;
}

export interface StoreOrder {
  id: string;
  created_at: string;
  shopify_order_id: string;
  order_number: string | null;
  customer_name: string | null;
  customer_email: string | null;
  customer_phone: string | null;
  line_items: StoreOrderLineItem[];
  subtotal: number | null;
  total_amount: number | null;
  currency: string | null;
  financial_status: string | null;
  fulfillment_status: string | null;
  shipping_address: Record<string, any> | null;
  processed_at: string | null;
}

export async function getStoreOrders(): Promise<{ success: boolean; data?: StoreOrder[]; error?: string }> {
  try {
    const { data, error } = await supabase
      .from('store_orders')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) throw error;
    return { success: true, data: (data ?? []) as StoreOrder[] };
  } catch (error: any) {
    console.error('Error fetching store orders:', error);
    return { success: false, error: error.message ?? 'Failed to fetch store orders' };
  }
}

export interface StoreOrderStats {
  count: number;
  revenue: number;
  thisMonthCount: number;
  thisMonthRevenue: number;
}

export function getStoreOrderStats(orders: StoreOrder[]): StoreOrderStats {
  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
  let revenue = 0;
  let thisMonthCount = 0;
  let thisMonthRevenue = 0;
  for (const o of orders) {
    const amt = o.total_amount ?? 0;
    revenue += amt;
    if (new Date(o.created_at).getTime() >= monthStart) {
      thisMonthCount += 1;
      thisMonthRevenue += amt;
    }
  }
  return { count: orders.length, revenue, thisMonthCount, thisMonthRevenue };
}
